<template>
  <!-- begin::Page loader -->
  <div class="page-loader page-loader-logo">
    <img alt="Logo" class="p-2" src="https://www.serpar.gob.pe/wp-content/uploads/2023/01/logo-serpar-2023-blanco.png" width="150" />
     <i class="el-icon-loading text-white h2"></i>
  </div>
  <!-- end::Page Loader -->
</template>

<script>
export default {
  name: "Loader",
  props: {
    logo: String,
    spinnerClass: String
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/Loader.vue